import axios from 'axios'
import { settingURL } from 'src/utilities/settingsUrlAPi'

interface RedundanceInterface {
  status: number
  data: any
  url: string
}

const setDataApi = (url: string) => {
  localStorage.setItem('api', url)
  setDataGestor(url)
}

const setDataGestor = (url: string) => {
  const config = settingURL.find((item) => item.url === url)
  if (!config) return
  localStorage.setItem('gestor', JSON.stringify(config.nsServers))
}

export const getDataGestor = () => {
  const gestor = localStorage.getItem('gestor')
  return JSON.parse(gestor || '[]')
}

export async function testingApis(
  urls: string[],
  tentativa = 0,
): Promise<RedundanceInterface> {
  const urlAtual = urls[tentativa]

  try {
    const response = await axios.get(`${urlAtual}:9000/workspace/TestarApi/`, {
      timeout: 5000,
      headers: {
        gatewayls: '2e44bb6339e6aacd8faeca8fd4e8694e',
      },
    })

    setDataApi(urlAtual)
    return { status: response.status, data: response.data, url: urlAtual }
  } catch (error: any) {
    console.error(`Erro na requisição para ${urlAtual}: ${error.message}`)

    // Tentar a próxima URL se houver
    if (tentativa < urls.length - 1) {
      return testingApis(urls, tentativa + 1)
    }

    throw new Error(
      'Todas as tentativas falharam. Não foi possível chamar a API.',
    )
  }
}
